export default {
  methods: {
    next(quiz) {
      let session = this.$cookies.get("bci_session");
      session["Quiz"] = quiz + 1;
      session["Answered"] = 0;
      this.$cookies.set("bci_session", session);
    },
  },
};
